// extracted by mini-css-extract-plugin
export default {"durationEdit":"duration-edit_durationEdit__EDrOB"};